import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GS_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GS_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 .1h32v24H0V.1z",
      fill: "#2B409A"
    }
  )),
  /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }),
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GS_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GS_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GS_svg__c",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#GS_svg__c)"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.32 18.551c-.062 0-.285-.12-.285-.12s-.161.256-.246.27c-.085.015-.523-.157-.523-.157s-.307.24-.377.225l-.776-.165-.385-.24s-.215.345-.223.337c-.007-.007-.646-.127-.646-.127s.193-.263.193-.27c0-.008-.093-.038-.093-.038l-.138.113-.569.052.138-.39.223-.331 2.73-2.593 1.346 2.427-.2.73s-.108.277-.17.277z",
      fill: "#6A4C2D"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.712 18.06c.095.116 1.347 1.396 1.55 2.002.203.605-1.647-.169-1.647-.169s2.33-1.513 3.494-1.513c1.163 0 3.45 1.514 3.45 1.514s-1.534 1.08-1.519.399c.016-.682.72-2.024 1.562-2.232",
      stroke: "#FB0",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.542 18.16l-.382-.143-.34-.449-1.402-.103-1.28-.349-.538.36.29.38.71.26 2.942.044z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.939 9.866c.013.033.3-.025.36.146.308-.455.67-.021.67-.021l.303-.36.344.325.314-.025.33.773-2.598-.049s.264-.822.277-.79zM26.632 13.154c-.02-.245-.238-.273-.359-.265-.12.008-.23.11-.23.11l-.4-.249s.2-1.235.413-1.313c.202-.142.238-.204.238-.236a.8.8 0 00-.075-.165l-1.306-.151-1.236.143s-.095.193-.083.25c.013.057.017.118.238.286.245.184.413 1.24.413 1.24s-.346.166-.367.146c-.02-.02-.125-.04-.18-.032a.327.327 0 00-.233.33c0 .232.18.367.18.367s1.18.865 1.356 1.183c.17-.383 1.293-1.248 1.427-1.314.054-.032.225-.085.204-.33z",
      fill: "#656263"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.81 12c.099-.063.752-.095.91 0 .156.097.215.57.215.57s.098.165.105.287c.006.121.02.204.02.204s.522.665.529 1.265c.058.409.045 1.5-.118 1.916-.007.517-.229.855-.229.855s.052.09.046.186c-.007.096-.059.185-.059.185l-.49.21-.542-.089-.615-1.794.144-3.034.04-.153-.066-.409s.013-.134.11-.198z",
      fill: "#000"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.263 13.594s.66 0 .732.21c.125-.28.697-.262.697-.262l1.037-.035.018 2.445c-.203.949-.906 1.618-1.68 1.903-.924-.29-1.507-1.053-1.698-1.92l-.107-2.324 1-.017z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.62 13.602l1.457 3.797 1.317-3.88c-.409.026-1.285-.062-1.394.302-.169-.326-1.09-.195-1.38-.219z",
      fill: "#006B00"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.308 14.197s.133.346 0 .518c-.132.17.011.311.091.311s.355.272.132.272c-.223 0-.348-.085-.348.154 0 .24.307 1.316.216 1.574-.09.258-.068.455.062.39.13-.066.212-.235.141-.56-.071-.324-.14-.247-.14-.528 0-.28.069-.593.069-.593s.117.088.034.408c-.084.32.103.762.103.883 0 .12.005.45-.066.483-.071.033-.136.233-.203.08-.066-.152-.108-.403-.193-.23-.085.173-.069.57-.157.589-.089.02-.22.207-.22.132 0-.076-.125-.212-.088-.34.038-.127.072-.141.102-.02.031.122.16.121.16.02 0-.1-.045-.05 0-.28.046-.229.096-.532 0-.513-.095.018-.242.167-.262-.108-.019-.275-.098-.404-.034-.457.063-.054.147-.245.174-.095.027.15-.092.294-.072.349.02.054.03.177.112.074.083-.103.131-.273.193-.116.061.158.063.034-.065-.266-.128-.3-.236-.466-.22-.729.014-.263-.006-.361.014-.446.021-.085-.228-.496-.165-.615.063-.118.088-.501.165-.432.078.069.118.161.078.264-.04.103-.08.206-.04.275.04.07.178.27.205.22.028-.05.12-.002.12-.288 0-.285-.103-.386-.038-.454.065-.067.14.075.14.075z",
      fill: "#FFD100"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M26.402 13.52l.196-.004-.35.434.42.48-.828 1.02.782.92a2.379 2.379 0 01-.319.563l-.449-.485.814-.993-.669-.74.403-1.195zM23.383 13.612l.393.416-.416.508.866.92-.717.937c.086.206.21.435.342.604l.426-.526-.875-.951.641-.796-.45-1.117-.21.005z",
      fill: "#1E5AA6"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.567 16.078l-.31.402 1.105 1.249c.195-.096.349-.206.516-.338l-.576-.65.234-.673.337.38-1.053 1.313a2.323 2.323 0 01-.548-.33l.557-.69-.262-.663z",
      fill: "#1E5AA6"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M28.386 12.85c0 .064.07 3.832.146 3.796.19-.09.233.106.233.106s.066.62-.098.703a2.41 2.41 0 01-.422.187l-.283-.206s-.288-.402-.353-.581c-.066-.179-.144-.977-.118-1.15.026-.172.046-1.182.033-1.232-.013-.052-.066-.895-.033-1.022.033-.128.235-.69.229-.69 0 0 .666.026.666.09z",
      fill: "url(#GS_svg__paint0_linear_4799_266024)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.732 12.206c.137 0 .242.115.274.217.007.044-.013.077-.006.16.006.083-.994.018-1 .012 0 0 .464-.44.732-.39z",
      fill: "#FF7000"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M28.83 17.667s.314-.07.399-.18c.052-.038.327.403-.399.18z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.5,
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M28.309 12.46a.05.05 0 11-.1 0 .05.05 0 01.1 0z", fill: "#000" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.82 11.908s.521.55.858.545c.061.161-.153.312-.239.383-.171-.053-.326.01-.724-.468.025-.306.112-.448.106-.46zM27.89 9.138c.05.353-.002.435-.025.583-.023.148.904.203 1.143-.09-.024.131-.303.668-1.564.662.478.443-.153.796-.423.688.496-.371-.14-.592-.496-.353.068-.204.564-1.227 1.366-1.49z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.052 11.618c-.095-.39-.141-.837.068-1.008-.276-.185-.576.006-.576.006a.176.176 0 01-.015.024c-.064.088-.279.384.015.916-.783-.203-.455.509-.398.562.031-.114.447-.221.552.36.035.117-.176.287-.244.341-.015.012-.023.018-.02.017 0 0 .663.135.75-.741.111-.067.664-.433.647-1.192-.507.01-.73.571-.78.715z",
      fill: "#00F"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.087 12.065s-.508.43-.796.293c-.214.125-.465-.096-.465-.096s.294 1.059 1.348.293a2.384 2.384 0 00-.087-.49z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.286 12.34c.043-.222.22-.33.361-.12.19.036.38-.724-.294-.599.19-.993-.38-1.364-.38-1.364s-.201 1.101-.11 1.304c.092.204-.134-.377-.863-.538-.012.832.815 1.22.815 1.22s.232.21.471.096z",
      fill: "#00F"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.597 11.139c-.214.065-.735-.249-.405-.656-1.084-.024-1.674-.94-1.312-.765.36.175.62-.197.889 0-.331-.299.115-.538.115-.538s.925.27 1.09 1.071c-.055.156-.08.43-.092.419 0-.006-.573-.01-.285.469z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.328 7.43c.005-.027.698-.265.745-.658.046-.393-.01-.128-.01-.128s.193-.178.122-.274c-.07-.096-.047.123-.159.119-.112-.005-.051-.238-.051-.238s-.01-.028-.043-.042c-.046.005-.154-.096-.154-.096s-.07-.091-.131.197c.033.307.234.247.234.448 0 .202-.178.357-.23.362-.05.004-.032-.17-.032-.17s-.028-.082-.047-.082.103-.018.084-.247c-.042-.274-.075.064-.15.05-.075-.013-.018-.251.01-.279.028-.027-.033-.141-.197.151-.014.142-.033-.036-.066-.027-.055.114-.046.197.033.302.117.105.192.21.188.265-.005.055-.066.179-.15.179-.084 0 .004-.151 0-.202-.005-.05-.145-.233-.145-.233s-.099-.156-.09-.16c.01-.005-.224.224-.083.343-.108-.014-.117.027-.117.027 0 .055.145.078.163.174.02.096-.15.151-.15.151s.071.096.267-.091c.005.119-.074.201-.074.201.065.029.116.026.126.1 0 0 .103-.114.107-.141zM23.578 7.572s-.087-.127-.091-.152c-.005-.024-.43.032-.633-.476-.13-.242 0-.1 0-.1l.008-.117s-.14-.167-.08-.254c.06-.087.035.112.112.113.096-.004.044-.217.044-.217s.008-.025.036-.037c.04.004.056.13.091.138.036.008.11-.148.133-.18.033-.004.032-.129.084.134-.028.278-.265.224-.265.407 0 .184.151.325.195.33.044.003.028-.155.028-.155s.024-.075.04-.075-.14.03-.123-.179c.035-.195.115.013.178 0 .064-.012-.007-.206.011-.235.005-.03.098-.157.134.123.012.13.084-.11.112-.102.048.104-.02.243-.088.338-.1.096-.145.201-.14.251.003.05.027.112.098.112.072 0 .025-.087.029-.133.003-.046.123-.194.123-.194.023-.036.004-.105.028-.136.04 0 .055-.053.095.093s.088-.096.088-.096.055.18-.064.287c.091-.012.1.025.1.025 0 .05-.044.071-.06.159a.146.146 0 00.047.137s-.06.087-.226-.083a.279.279 0 00.064.183c-.056.026-.1.023-.108.091z",
      fill: "#CDAD56"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.677 7.474c-.103.299-.472.186-.472.186s.012.15-.024.221c.03.022.248.19.477.233.33.063 1.004-.108 1.23.144.227.252.215.455.215.455s-.294.033-.212.137c.053.068.2.118.213.187.04.222-.139.621-.074.77-.102.01-.11.114-.11.114-.006.119-.3.049-.3.049s.183-.461.195-.569c.013-.108-.128-.3-.238-.3-.11 0-.19.342-.19.342s-.055.257-.037.281c.019.024-.073-.084-.073-.084s-.03.105-.077.168c-.053.07-.125.101-.125.101s-.055-.155-.037-.215c.018-.06.3-.293.276-.46-.011-.075-.021-.204-.114-.246-.117-.055-.332-.015-.462-.042-.072.122-.104.79-.055.832.049.042-.123.131-.123.131l-.202.006c-.003-.09.12-.338.12-.547 0-.21.015-.434.015-.434s-.136.034-.208.168c-.061.112-.061.323-.055.353.012.066.073.251.055.305-.019.054-.337.126-.337.126l-.012-.174s.134-.084.134-.293c0-.21.012-.509.006-.527-.003-.01-.11-.469-.25-.778-.094-.206-.238-.3-.245-.317-.019-.042-.019-.09-.019-.09s-.202.144-.44-.161c.218-.183.453-.048.453-.048s.06-.168.342-.156c.282.012.337.168.325.15 0 0 .208-.18.434-.018z",
      fill: "#923F00"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.781 10.588c.005 0 .52.015.525.284.005.269-.158.2-.163.2l-.377-.045.015-.44z",
      fill: "#00F"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.281 10.513s.643-.005.607.269c-.036.274-.199.22-.199.22l-.31-.026-.098-.463z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.92 10.482l.371.03s.225.03.215.24c-.01.209-.23.214-.23.214l-.362-.02.005-.464z",
      fill: "#00F"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.049 10.588c-.005 0-.52.015-.526.284-.004.269.159.2.164.2l.377-.045-.015-.44z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.548 10.513s-.643-.005-.607.269c.036.274.199.22.199.22l.31-.026.098-.463z",
      fill: "#00F"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.91 10.482l-.373.03s-.225.03-.214.24c.01.209.229.214.229.214l.362-.02-.005-.464z",
      fill: "#F7FCFF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M26.287 13.164c.099.032.024.33-.023.358l-.357-.013s.267-.386.38-.345zM24.073 13.577c-.085-.115-.207-.431-.32-.344-.098.032-.023.33.024.358l.296-.014z",
      fill: "#5E0043"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.628 11.363l1.289.824 1.16-.762s.242-.13.221-.225c-.02-.093-.104-.057-.146-.04-.042.016-1.214.828-1.214.828l-1.248-.771s-.092-.029-.109.028c-.016.057.035.09.047.118z",
      fill: "#B4B6B9"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.948 17.427s-.564.17-.407.175c.116.004.676 0 .676 0l-.27-.175zM28.175 17.613l-.5.014s-.126.112-.134.139c-.007.027.083.034.083.034s.516.131.906.046c.197-.067.232-.148.094-.197-.138-.049-.445-.034-.449-.036z",
      fill: "#FF7000"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.391 12.99s-.065.2 0 .3c.065.1.475.908.475.908s.279-.336.381-.345c.102-.009.056.873.056.873s-.168.154-.27.145c-.102-.01.251.345.242.646-.01.3-.465 1.79-.633 1.817-.167.028-.311-.28-.311-.547 0-.266.172-.689.163-.807-.01-.118-.832 1.267-.882 1.483-.01.041.045.19.045.19s-.323.026-.252.436c-.948-.327-1.414-.89-1.404-1.463.003-.22-.206-.736 0-1.306.331-.918 1.138-1.966 1.144-2.067.01-.164.074-.236.084-.327.009-.09-.028-.555.065-.636.093-.082.576-.282.697-.273.121.009.224.09.224.09s.455 0 .483.173c.028.173-.093.237-.093.237s.065.245-.214.472z",
      fill: "#8A9396"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.663 18.145c.153.106.508.169.508.169s-.872.235-1.758-.221c-.08-.355.19-.434.258-.437.156-.041.838.382.992.489z",
      fill: "#2B2B2B"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.73 18.108c.953.504 1.056.164 1.713-.315.046-.033.262.77 1.184.315 1.303-.645-1.118-1.718-1.46-1.695-.342.024-2.392 1.19-1.438 1.695z",
      fill: "#00713D"
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "GS_svg__paint0_linear_4799_266024",
      x1: 28.276,
      y1: 15.606,
      x2: 29.019,
      y2: 15.598,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#D5DFFF" }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#fff" })
  ))
);
export {
  t as default
};
